import React from 'react';

const SbBetsSumPercent = () => {
    return (
        <div>

        </div>
    )
}

export default SbBetsSumPercent;